import * as React from 'react';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { ExternalIdsData } from '../../../Settings/externs/data';
import { IntlShape, useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { ConnectOrcidFormData } from './ConnectOrcidFormData';
import { Mandant } from '../../../util/types';

interface Props {
  revoked: boolean;
  submit: (data: ConnectOrcidFormData) => void;
  mandant: Mandant;
}

export const OrcidGrandRightsForm = ({revoked, submit, mandant}: Props): ReactNode => {
  const [orcid, setOrcid] = React.useState<ConnectOrcidFormData>({
    read_limited: false,
    activities_update: false,
    publicUsageOfLimitedOrcidData: false,
  });
  const intl: IntlShape = useIntl();
  return (
    <form
      onSubmit={(e): void => {
        e.preventDefault();
        submit(orcid);
      }}
    >
      {revoked && <p><strong>{intl.formatMessage({ id: `settings.orcid.revoked` })}</strong></p>}
      <div className={'flex gap-2'}>
        <Checkbox
          id={'read_limited'}
          checked={orcid.read_limited}
          onChange={(e: CheckboxChangeEvent): void => setOrcid((data: ConnectOrcidFormData): ConnectOrcidFormData => ({ ...data, read_limited: e.checked }))}
        />
        <div>
          <label htmlFor={'read_limited'}>{intl.formatMessage({ id: `settings.orcid.scopes.readLimited` })}</label>
          <p>{intl.formatMessage({ id: 'settings.orcid.scopes.readLimited.desc(mandant)'}, {mandant: intl.formatMessage({ id: `core.mandant.${mandant}`}) })}</p>
        </div>
      </div>
      <div className={'flex gap-2'}>
        <Checkbox
          id={'activities_update'}
          checked={orcid.activities_update}
          onChange={(e: CheckboxChangeEvent): void => setOrcid((data: ConnectOrcidFormData): ConnectOrcidFormData => ({ ...data, activities_update: e.checked }))}
        />
        <div>
          <label htmlFor={'activities_update'}>{intl.formatMessage({ id: `settings.orcid.scopes.activitiesUpdate` })}</label>
          <p>{intl.formatMessage({ id: 'settings.orcid.scopes.activitiesUpdate.desc(mandant)'}, {mandant: intl.formatMessage({ id: `core.mandant.${mandant}`}) })}</p>
        </div>
      </div>
      <div className={'flex gap-2'}>
        <Checkbox
          id={'publicUsageOfLimitedOrcidData'}
          checked={orcid.publicUsageOfLimitedOrcidData}
          onChange={(e: CheckboxChangeEvent): void => setOrcid((data: ConnectOrcidFormData): ConnectOrcidFormData => ({ ...data, publicUsageOfLimitedOrcidData: e.checked }))}
        />
        <label htmlFor={'publicUsageOfLimitedOrcidData'}>{intl.formatMessage({ id: `settings.orcid.notLinked.publicUsageOfLimitedOrcidData` })}</label>
      </div>
      <p>{intl.formatMessage({ id: `settings.orcid.notLinked.connectInfotext` })}</p>
      <Button
        icon={
          <img
            className={'w-2rem h-2rem mr-3'}
            alt={`${ExternalIdsData.orcid.name} Logo`}
            src={ExternalIdsData.orcid.icon}
          />
        }
        label={intl.formatMessage({ id: `settings.orcid.button.grandRights` })}
        type={'submit'}
      />
    </form>
  );
};
